import RenderHTML from '../../../../../../components/ui-components/RenderHTML'
import type { PlanFundRecommendationStatus } from './PlansFundCard'

type PlanFundRecommendationStatusTagProps = {
  recommendationStatus?: PlanFundRecommendationStatus | null
  recommendationStatusDisplayText?: string
}

export function PlanFundRecommendationStatusTag({
  recommendationStatus,
  recommendationStatusDisplayText = ''
}: PlanFundRecommendationStatusTagProps) {
  if (recommendationStatus === 'UPDATED') {
    return <PlanUpdatedTag recommendationStatusDisplayText={recommendationStatusDisplayText} />
  }

  if (recommendationStatus === 'NEW') {
    return <PlanNewTag recommendationStatusDisplayText={recommendationStatusDisplayText} />
  }

  if (recommendationStatus === 'SAME') {
    return <PlanSameTag recommendationStatusDisplayText={recommendationStatusDisplayText} />
  }

  return null
}

export function PlanUpdatedTag({
  recommendationStatusDisplayText = ''
}: {
  recommendationStatusDisplayText?: string
}) {
  const displayText = recommendationStatusDisplayText.trim()

  return (
    <div className="flex items-center">
      <div className="bg-gradient-to-r from-[rgba(20,112,204,0.1)] to-[rgba(20,112,204,0)] flex items-center gap-1.5 pl-2 pr-6 py-[2px] rounded-[8px]">
        {/* <PlanUpdatedReloadIcon /> */}
        {displayText ? (
          <span className="text-[13px] font-[500] leading-[140%] text-[#1470CC] whitespace-nowrap">{displayText}</span>
        ) : null}
      </div>
    </div>
  )
}

export function PlanNewTag({
  recommendationStatusDisplayText = ''
}: {
  recommendationStatusDisplayText?: string
}) {
  const displayText = recommendationStatusDisplayText.trim()

  return (
    <div className="flex items-center">
      <div className="bg-gradient-to-r from-[rgba(42,156,74,0.11)] to-[rgba(42,156,74,0)] flex items-center gap-1.5 pl-2 pr-6 py-[2px] rounded-[8px]">
        {/* <PlanNewSparkIcon /> */}
        {displayText ? (
          <span className="text-[13px] font-[500] leading-[140%] text-[#2A9C4A] whitespace-nowrap">{displayText}</span>
        ) : null}
      </div>
    </div>
  )
}

export function PlanSameTag({
  recommendationStatusDisplayText = ''
}: {
  recommendationStatusDisplayText?: string
}) {
  const displayText = recommendationStatusDisplayText.trim()

  return (
    <div className="flex items-center">
      <div className="bg-gradient-to-r from-[rgba(106,110,110,0.12)] to-[rgba(106,110,110,0)] flex items-center gap-1.5 pl-2 pr-6 py-[2px] rounded-[8px]">
        {displayText ? (
          <span className="text-[13px] font-[500] leading-[140%] text-[#6A6E6E] whitespace-nowrap">{displayText}</span>
        ) : null}
      </div>
    </div>
  )
}

export function PlanUpdatedReloadIcon() {
  return (
    <RenderHTML innerHTMLText={`<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.01733 0.125538C7.89476 0.0029676 7.71043 -0.0336991 7.55028 0.0326355C7.39013 0.0989705 7.28571 0.255243 7.28571 0.428584V1.7143H2.14286C0.959391 1.7143 0 2.67369 0 3.85716V5.14287C0 5.61625 0.383756 6.00001 0.857143 6.00001C1.33053 6.00001 1.71429 5.61625 1.71429 5.14287V3.85716C1.71429 3.62046 1.90617 3.42858 2.14286 3.42858H7.28571V4.7143C7.28571 4.88764 7.39013 5.04391 7.55028 5.11025C7.71043 5.17658 7.89476 5.13991 8.01733 5.01734L10.1602 2.87448C10.3275 2.70712 10.3275 2.43576 10.1602 2.2684L8.01733 0.125538ZM4.44972 6.88978C4.60987 6.95611 4.71429 7.11239 4.71429 7.28573V8.57144H9.85714C10.0938 8.57144 10.2857 8.37956 10.2857 8.14287V6.85716C10.2857 6.38377 10.6695 6.00001 11.1429 6.00001C11.6163 6.00001 12 6.38377 12 6.85716V8.14287C12 9.32633 11.0406 10.2857 9.85714 10.2857H4.71429V11.5714C4.71429 11.7448 4.60987 11.901 4.44972 11.9674C4.28957 12.0337 4.10524 11.9971 3.98267 11.8745L1.83981 9.73167C1.67244 9.56427 1.67244 9.2929 1.83981 9.1255L3.98267 6.98268C4.10524 6.86011 4.28957 6.82344 4.44972 6.88978Z" fill="#1470CC"/>
</svg>`} />
  )
}

export function PlanNewSparkIcon() {
  return (
    <RenderHTML innerHTMLText={`<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M4.90766 3.16709L5.72384 1.18494C5.76992 1.07303 5.87904 1 6 1C6.12096 1 6.23008 1.07303 6.27616 1.18494L7.09232 3.16709C7.41728 3.95616 8.04384 4.58275 8.83296 4.90766L10.815 5.72386C10.927 5.76992 11 5.87898 11 6C11 6.12102 10.927 6.23008 10.815 6.27614L8.83296 7.09234C8.04384 7.41725 7.41728 8.04384 7.09232 8.83291L6.27616 10.8151C6.23008 10.927 6.12096 11 6 11C5.87904 11 5.76992 10.927 5.72384 10.8151L4.90766 8.83291C4.58275 8.04384 3.95616 7.41725 3.16709 7.09234L1.18493 6.27614C1.07304 6.23008 1 6.12102 1 6C1 5.87898 1.07304 5.76992 1.18493 5.72386L3.16709 4.90766C3.95616 4.58275 4.58275 3.95616 4.90766 3.16709Z" stroke="#2A9C4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`} />
  )
}
